module.exports = __webpack_public_path__ + "static/media/calendar-new.90f692d1.svg";